/* One scroll controller: natural initial scroll, then a short transform slide. */
(() => {
  let dispose;
  function initialize() {
    dispose?.();
    const section = document.querySelector('.header-section');
    const header = section?.querySelector('header');
    const upper = header?.querySelector('.header__top');
    const nav = header?.querySelector('.header__bottom');
    if (!section || !header || !upper || !nav) return;
    const marker = document.createElement('div');
    marker.setAttribute('aria-hidden', 'true');
    marker.style.cssText = 'display:block!important;height:0;pointer-events:none';
    section.before(marker);
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const mobile = matchMedia('(max-width:1023.98px)');
    let total = 60, collapse = 60, origin = 0;
    let lastY = Math.max(0, scrollY), direction = 0, travel = 0, frame = 0;
    let revealed = false, lastOffset = -1, lastNatural = null;
    section.classList.add('p6-header-section');
    document.body.classList.add('p6-header-active');

    function locked() {
      return document.body.classList.contains('search-open') ||
        !!document.querySelector('#MenuDrawer[open],#MenuDrawer[active],#CartDrawer[open],#CartDrawer[active]') ||
        (header.contains(document.activeElement) && /^(INPUT|TEXTAREA)$/.test(document.activeElement.tagName));
    }
    function update() {
      frame = 0;
      const y = Math.max(0, scrollY);
      const delta = y - lastY;
      const next = Math.sign(delta);
      if (next && next !== direction) { direction = next; travel = 0; }
      travel += Math.abs(delta);
      const isLocked = locked();
      if (isLocked) revealed = true;
      else if (y <= origin) { revealed = false; travel = 0; }
      else if (next && travel >= 6) revealed = direction < 0;
      const natural = y <= origin;
      const offset = revealed || natural ? 0 : collapse;
      // Once the header reaches the top, collapse in one compositor animation.
      // Do not chase each scroll event with a new partial transform target.
      if (natural !== lastNatural) {
        section.classList.toggle('p192-natural-scroll', natural);
        lastNatural = natural;
      }
      if (offset !== lastOffset) {
        section.classList.toggle('p194-header-collapsing', offset > 0);
        header.style.setProperty('--p192-header-transform', offset ? `translate3d(0,-${offset}px,0)` : 'none');
        lastOffset = offset;
      }
      const pinned = y >= origin + collapse;
      section.classList.toggle('p6-header-hidden', !revealed && pinned);
      section.classList.toggle('p6-nav-pinned', !mobile.matches && pinned);
      section.classList.toggle('p9-desktop-revealed', !mobile.matches && revealed);
      document.body.classList.toggle('header-pinned', y >= origin && (revealed || !mobile.matches));
      const bottom = Math.max(0, origin - y) + total - offset;
      document.body.style.setProperty('--p6-visible-header-height', `${Math.max(0, bottom)}px`);
      document.documentElement.style.setProperty('--header-bottom-position', `${Math.max(0, bottom)}px`);
      if (document.querySelector('#MenuDrawer[open]')) {
        document.documentElement.style.setProperty('--p7-menu-top', `${Math.max(0, origin - y) + total}px`);
      }
      lastY = y;
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    function measure() {
      total = header.offsetHeight;
      collapse = mobile.matches ? total : upper.offsetHeight;
      origin = marker.getBoundingClientRect().top + Math.max(0, scrollY);
      section.style.setProperty('--p6-header-total-height', `${total}px`);
      section.style.setProperty('--p6-header-upper-height', `${upper.offsetHeight}px`);
      section.style.setProperty('--p6-header-nav-height', `${mobile.matches ? 0 : nav.offsetHeight}px`);
      header.querySelector('.header__logo')?.style.removeProperty('transform');
      schedule();
    }
    const resize = new ResizeObserver(measure);
    resize.observe(header);
    resize.observe(upper);
    for (const sibling of section.parentElement.children) {
      if (sibling === section) break;
      if (sibling.classList.contains('shopify-section')) resize.observe(sibling);
    }
    let searchOpen = document.body.classList.contains('search-open');
    const mutation = new MutationObserver(records => {
      const currentSearch = document.body.classList.contains('search-open');
      if (currentSearch !== searchOpen || records.some(record => record.target !== document.body)) schedule();
      searchOpen = currentSearch;
    });
    mutation.observe(document.body, { attributes:true, attributeFilter:['class'] });
    for (const drawer of document.querySelectorAll('#MenuDrawer,#CartDrawer')) {
      mutation.observe(drawer, { attributes:true, attributeFilter:['open','active','hidden'] });
    }
    window.addEventListener('scroll', schedule, { ...options, passive:true });
    window.addEventListener('resize', measure, options);
    mobile.addEventListener('change', () => { direction = 0; travel = 0; measure(); }, options);
    header.addEventListener('focusin', schedule, options);
    header.addEventListener('focusout', schedule, options);
    document.addEventListener('menu-drawer:open', schedule, options);
    window.visualViewport?.addEventListener('resize', schedule, options);
    measure();
    dispose = () => {
      controller.abort(); resize.disconnect(); mutation.disconnect(); cancelAnimationFrame(frame);
      marker.remove(); header.style.removeProperty('--p192-header-transform');
      section.classList.remove('p192-natural-scroll');
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once:true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
